import { useEffect, useState } from "react"

export function useConditionalState({ bool = true, defaultCase = "", trueCase = "" }) {
  const [state, setState] = useState(defaultCase)

  useEffect(() => {
    if (bool) {
      setState(trueCase)
    } else {
      setTimeout(() => {
        setState(defaultCase)
      }, 5)
    }
  }, [bool, defaultCase, trueCase])

  return state
}
